import { ChevronRight } from 'lucide-react';
import { FaIcon } from '../../../../design-system/icon/fa-icon';
import { Inline } from '../../../../design-system/inline/inline';
import { cn } from '../../../../utils/cn';

type CategorySelectTriggerContentProps = {
  level1?: string;
  level2?: string;
  icon?: string;
};

export const CategorySelectTriggerContent = ({ level1, level2, icon }: CategorySelectTriggerContentProps) => {
  const triggerTextClassName = 'text-base font-medium text-black';

  if (!level1 || !level2 || !icon) {
    return <p className={triggerTextClassName}>Select a category</p>;
  }

  return (
    // Arbitrary width to ensure the truncate in the p below works
    // It should be dynamic in the ideal world but I haven't figured out how to do that yet and it has been taking too long by now
    <Inline wrap="nowrap" className="w-[50%]">
      <p className={cn(triggerTextClassName, 'text-nowrap')}>{level1}</p>

      <div className="h-4 w-4 shrink-0">
        <ChevronRight className="h-full w-full text-muted-foreground" />
      </div>

      <Inline space={2} wrap="nowrap" className="w-full">
        <FaIcon iconName={icon} />

        <p className={cn(triggerTextClassName, 'truncate')}>{level2}</p>
      </Inline>
    </Inline>
  );
};
